/**
 * The people Vendor Relations deals with at an airline or car company.
 *
 * The SupplierContacts component with the vendor adapter: /api/btp/vendor-contacts,
 * 'left_company' as the departed status, and no feed row — Andavo's vendor table
 * carries no contacts, so every row here is ours and editable, and the Source
 * column the hotel panel needs is not shown.
 */
import {
  SupplierContacts,
  type ContactsAdapter,
  type SupplierContactRow,
} from './SupplierContacts';

const VENDOR_COPY: ContactsAdapter['copy'] = {
  parent: 'this vendor',
  retry: 'Reload the page to retry.',
  empty:
    'No contact recorded for this vendor yet. Add the account manager or sales ' +
    'contact you work with here.',
  allRetired:
    'Every contact recorded for this vendor has been removed as no longer there. ' +
    'They are kept below so past history still resolves to a name.',
  addButton: 'Add vendor point of contact',
  primaryLabel: 'Primary contact for this vendor',
  departedLabel:
    'They have left the company — keep the record, stop offering them',
  departedPrimaryHint: '— not available once they have left',
};

export function VendorContacts({
  vendorUid,
  testId = 'vendor-contacts',
  initialContacts,
}: {
  vendorUid: string;
  testId?: string;
  /** See SupplierContactsProps.initialContacts. */
  initialContacts?: SupplierContactRow[];
}) {
  return (
    <SupplierContacts
      initialContacts={initialContacts}
      adapter={{
        endpoint: '/api/btp/vendor-contacts',
        parentParam: 'vendor_uid',
        parentId: vendorUid,
        departedStatus: 'left_company',
        hasFeed: false,
        copy: VENDOR_COPY,
      }}
      testId={testId}
    />
  );
}
